import styled from 'styled-components'
import AppButton from 'Components/AppButton'
import Flex from 'Components/Flex'
import {
  ERROR_BG_COLOR, CLICKABLE_COLOR, HYPER_LINK_COLOR, BORDER_PRIMARY,
} from '@CSSVars/colors'


export const _Login = styled.div`
  h4 {
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    margin-bottom: 24px;
  }

  input {
    border-radius: 10px;
  }

  ${({ listingCard }) => (
    listingCard ?
      `
        padding-top: 10px;

        @media screen and (max-width: 414px) {
          h4 {
            margin: 5px 0 5px;
          }
        }
      ` : ''
  )}
`

export const _LoginlMainError = styled.div`
  width: 100%;
  padding: 8px 15px;
  margin-bottom: 24px;
  line-height: 28px;
  background-color: ${ERROR_BG_COLOR};
`

export const _Forgot = styled.button`
  text-decoration: underline;
  color: ${CLICKABLE_COLOR};
  cursor: pointer;
  border: none;
  &:focus {
    color: ${HYPER_LINK_COLOR};
  }
  padding: 0;
`

export const _SubmitCta = styled(AppButton)`
  width: 100%;
  position: relative;
  text-transform: none;
`

export const _RememberMe = styled(Flex)`

  label {
    font-size: 14px;
  }
  > div:last-child {
   //margin-left: 12px;
  }
  ${({ loginPage }) => loginPage && 'margin-bottom: 20px'};
`

export const _RememberForgotContainer = styled(Flex)`
  margin-bottom: 24px;

 ${({ loginPage }) => loginPage && `
    flex-direction: column;
    align-items: flex-start;
 `};
  @media screen and (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    ${_RememberMe} {
      margin-bottom: 20px;
    }
  }
`
export const _Divider = styled.div`
 display: flex;
align-items: center;
text-align: center;
color: ${BORDER_PRIMARY};
margin: 24px 0 12px;
font-size: 14px;
::before,
::after {
content: "";
flex: 1;
border-bottom: 1px solid ${BORDER_PRIMARY};
margin: 0 8px;
}
`
